class FairfaxProduct extends BaseElement {
  init() {
    this.initReservationCard();
  }

  initReservationCard() {
    const card = this.querySelector('.fairfax-reservation-card');
    if (!card) return;

    // Quantity controls
    const quantityInput = card.querySelector('input[name="reservation_quantity"]');
    const minusBtn = card.querySelector('.fairfax-reservation-card-quantity-minus');
    const plusBtn = card.querySelector('.fairfax-reservation-card-quantity-plus');

    if (minusBtn && quantityInput) {
      minusBtn.addEventListener('click', (e) => {
        e.preventDefault();
        const val = parseInt(quantityInput.value) || 0;
        if (val > 0) {
          quantityInput.value = val - 1;
          this.updateReserveButton(card);
        }
      });
    }

    if (plusBtn && quantityInput) {
      plusBtn.addEventListener('click', (e) => {
        e.preventDefault();
        const val = parseInt(quantityInput.value) || 0;
        quantityInput.value = val + 1;
        this.updateReserveButton(card);
      });
    }
  }

  updateReserveButton(card) {
    const btn = card.querySelector('.fairfax-reservation-card-reserve-btn');
    const quantityInput = card.querySelector('input[name="reservation_quantity"]');
    if (!btn || !quantityInput) return;

    const qty = parseInt(quantityInput.value) || 0;
    const emptyText = btn.dataset.addToCartEmptyText || 'Reserve';
    const addText = btn.dataset.addToCartText || 'Reserve';

    btn.textContent = qty > 0 ? addText : emptyText;
  }
}

if (!customElements.get('product-main')) {
  customElements.define('product-main', FairfaxProduct);
}
